'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.getAll = getAll;
exports.clear = clear;

var _styleSheet = require('./utils/style-sheet');

var _styleSheet2 = _interopRequireDefault(_styleSheet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styleSheet = new _styleSheet2.default();
styleSheet.inject();

function add(styles) {
  styleSheet.insert(styles);
}

function getAll() {
  // Convert rules array to a string
  return styleSheet.rules().reduce(function (combinedRules, rule) {
    return combinedRules + rule.cssText;
  }, '');
}

function clear() {
  styleSheet.flush();
  styleSheet.inject();
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9zdHlsZXMuanMiXSwibmFtZXMiOlsiYWRkIiwiZ2V0QWxsIiwiY2xlYXIiLCJzdHlsZVNoZWV0IiwiU3R5bGVTaGVldCIsImluamVjdCIsInN0eWxlcyIsImluc2VydCIsInJ1bGVzIiwicmVkdWNlIiwiY29tYmluZWRSdWxlcyIsInJ1bGUiLCJjc3NUZXh0IiwiZmx1c2giXSwibWFwcGluZ3MiOiI7Ozs7O1FBS2dCQSxHLEdBQUFBLEc7UUFJQUMsTSxHQUFBQSxNO1FBT0FDLEssR0FBQUEsSzs7QUFoQmhCOzs7Ozs7QUFFQSxJQUFNQyxhQUFhLElBQUlDLG9CQUFKLEVBQW5CO0FBQ0FELFdBQVdFLE1BQVg7O0FBRU8sU0FBU0wsR0FBVCxDQUFhTSxNQUFiLEVBQXFCO0FBQzFCSCxhQUFXSSxNQUFYLENBQWtCRCxNQUFsQjtBQUNEOztBQUVNLFNBQVNMLE1BQVQsR0FBa0I7QUFDdkI7QUFDQSxTQUFPRSxXQUNKSyxLQURJLEdBRUpDLE1BRkksQ0FFRyxVQUFDQyxhQUFELEVBQWdCQyxJQUFoQjtBQUFBLFdBQXlCRCxnQkFBZ0JDLEtBQUtDLE9BQTlDO0FBQUEsR0FGSCxFQUUwRCxFQUYxRCxDQUFQO0FBR0Q7O0FBRU0sU0FBU1YsS0FBVCxHQUFpQjtBQUN0QkMsYUFBV1UsS0FBWDtBQUNBVixhQUFXRSxNQUFYO0FBQ0QiLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFN0eWxlU2hlZXQgZnJvbSAnLi91dGlscy9zdHlsZS1zaGVldCdcblxuY29uc3Qgc3R5bGVTaGVldCA9IG5ldyBTdHlsZVNoZWV0KClcbnN0eWxlU2hlZXQuaW5qZWN0KClcblxuZXhwb3J0IGZ1bmN0aW9uIGFkZChzdHlsZXMpIHtcbiAgc3R5bGVTaGVldC5pbnNlcnQoc3R5bGVzKVxufVxuXG5leHBvcnQgZnVuY3Rpb24gZ2V0QWxsKCkge1xuICAvLyBDb252ZXJ0IHJ1bGVzIGFycmF5IHRvIGEgc3RyaW5nXG4gIHJldHVybiBzdHlsZVNoZWV0XG4gICAgLnJ1bGVzKClcbiAgICAucmVkdWNlKChjb21iaW5lZFJ1bGVzLCBydWxlKSA9PiBjb21iaW5lZFJ1bGVzICsgcnVsZS5jc3NUZXh0LCAnJylcbn1cblxuZXhwb3J0IGZ1bmN0aW9uIGNsZWFyKCkge1xuICBzdHlsZVNoZWV0LmZsdXNoKClcbiAgc3R5bGVTaGVldC5pbmplY3QoKVxufVxuIl19


//////////////////
// WEBPACK FOOTER
// ./~/ui-box/lib/styles.js
// module id = 114
// module chunks = 0